import React, { useState } from 'react';
import { BarChart3, Upload, FileText, X, Loader2, TrendingUp, AlertCircle, CheckCircle } from 'lucide-react';
import './ReportsPage.css';

const ReportsPage = () => {
  const [cvFile, setCvFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [report, setReport] = useState(null);

  const handleAnalyze = async () => {
    if (!cvFile) return;
    setLoading(true);
    try {
      // TODO: API entegrasyonu — POST /api/Career/CareerReport { Cv }
      await new Promise(r => setTimeout(r, 2000));
      setReport({
        score: 72,
        summary: 'Profiliniz genel olarak güçlü ancak bazı alanlarda geliştirme potansiyeli mevcut.',
        strengths: ['Teknik yetkinlikler sektör ortalamasının üzerinde', 'İş deneyimi süresi yeterli', 'Eğitim profili pozisyona uygun'],
        improvements: ['Liderlik deneyimi eksik', 'Sertifikasyon sayısı artırılabilir', 'Yabancı dil seviyesi geliştirilebilir'],
        suggestions: ['Proje yönetimi sertifikası alın', 'İngilizce seviyenizi B2\'ye çıkarın', 'LinkedIn profilinizi güncelleyin'],
      });
    } catch {
      setReport(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="reports-page">
      <div className="reports__container">
        <div className="reports__header">
          <BarChart3 size={24} />
          <div>
            <h1 className="reports__title">Kariyer Raporu</h1>
            <p className="reports__subtitle">CV'ni yükle, yapay zeka kariyer analizini görsün.</p>
          </div>
        </div>

        {!report && (
          <div className="reports__upload-card">
            <input
              type="file"
              accept=".pdf,.doc,.docx"
              className="reports__file-input"
              id="report-cv"
              onChange={(e) => { if (e.target.files[0]) setCvFile(e.target.files[0]); }}
            />
            {!cvFile ? (
              <label htmlFor="report-cv" className="reports__upload-area">
                <Upload size={28} />
                <span>CV'ni yükle</span>
              </label>
            ) : (
              <div className="reports__cv-selected">
                <div className="reports__cv-badge">
                  <FileText size={16} />
                  <span>{cvFile.name}</span>
                  <button onClick={() => setCvFile(null)}><X size={14} /></button>
                </div>
                <button className="reports__analyze-btn" onClick={handleAnalyze} disabled={loading}>
                  {loading ? <><Loader2 size={16} className="reports__spinner" /> Analiz ediliyor...</> : 'Raporu Oluştur'}
                </button>
              </div>
            )}
          </div>
        )}

        {report && (
          <div className="reports__result">
            <div className="reports__score-card">
              <div className="reports__score-circle">
                <span className="reports__score-value">{report.score}</span>
                <span className="reports__score-label">puan</span>
              </div>
              <p className="reports__score-summary">{report.summary}</p>
            </div>

            <div className="reports__sections">
              <div className="reports__section reports__section--green">
                <h3><CheckCircle size={16} /> Güçlü Yönler</h3>
                <ul>{report.strengths.map((s, i) => <li key={i}>{s}</li>)}</ul>
              </div>
              <div className="reports__section reports__section--orange">
                <h3><AlertCircle size={16} /> Gelişim Alanları</h3>
                <ul>{report.improvements.map((s, i) => <li key={i}>{s}</li>)}</ul>
              </div>
              <div className="reports__section reports__section--blue">
                <h3><TrendingUp size={16} /> Öneriler</h3>
                <ul>{report.suggestions.map((s, i) => <li key={i}>{s}</li>)}</ul>
              </div>
            </div>

            <button className="reports__retry" onClick={() => { setReport(null); setCvFile(null); }}>
              Farklı CV ile Tekrar Dene
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReportsPage;
